import { BaseIntegration, BaseIntegrationState } from '@/models/integrations/BaseIntegration';
import { IntegrationKlasselotterietSegmentsData } from './Data';

export type IntegrationKlasselotterietSegmentsState = BaseIntegrationState;

export class IntegrationKlasselotterietSegmentsModel extends BaseIntegration<
  IntegrationKlasselotterietSegmentsData,
  IntegrationKlasselotterietSegmentsState
> {
  authorSignature(): string {
    return 'Dannie Hansen';
  }

  hasVueComponent() {
    return false;
  }
}
